export default "__VITE_ASSET__Jb7NBEfz__"